define([
	'jquery',
	'cycle',
	'Handlebars',
	'handlebars-core',
	'shared.main.screen'
], function($, cycle, Handlebars, HandlebarsCore, screenSize) {

// Name the plugin
var PLUGIN_IDENTIFIER = 'bloomreachProductCompare';
var DEBUG = false;

// Create the function that will be bound to JQuery
var bloomreachProductCompare = function(element, options) {
	this.element = element;
	this.options = options;
};

// Define the plugin's prototype and defaults
	bloomreachProductCompare.prototype = {
	defaults: {
		template: 'html.br-widget.br-widget-carousel-arrows',
		productClass: ".br-sf-widget",
		productCountPrefix: "br-sf-widget-product-",
		carousel: {
			enable: false,
			mobileOnly: true,
			carouselSelector: '#br-more-results-widget',
			includeArrows: true,
			carouselOptions: {

			}
		}
	},

	/**
	 * Initializes the plugin instance
	 * @returns {Object} This plugin instance
	 */
	init: function() {
		var self = this;

		if (DEBUG) console.log('Initializing ', PLUGIN_IDENTIFIER, 'on', $(self.element));

		// Merge various methods of providing plugin options into a single config object
		self.metadata = $(self.element).data(PLUGIN_IDENTIFIER+'Options');
		self.config = $.extend(true,
			{}, // empty object to merge into
			self.defaults, // defaults hardcoded into the prototype defined in this file
			self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
			self.metadata // options provided as HTML data attribute $(selector).data()
		);

		self.$brProducts = $(self.config.productClass);
		self.$element = $(self.element);

		// Do any DOM manipulation or other setup
		self._build();

		// Allow JQuery-style chaining of the plugin
		return self;
	},

	/**
	 * Modifies the DOM to support layout requirements
	 **/
	_build: function() {
		var self = this;

		// set class on products corresponding to the number of products
		if( self.$brProducts.length) {
			self.$brProducts.addClass(self.config.productCountPrefix + self.$brProducts.length);
		}

		if( self.config.carousel.enable ){
			if(screenSize.size() == 'small' || !self.config.carousel.mobileOnly ) {
				self.$carousel = self.$element.find(self.config.carousel.carouselSelector);
				return self.loadAndCompileTemplate().done(function () {
					self.render(self.config);
				});
			}
		}
	},
	/**
	 * render()
	 * Renders our Handlebars template.
	 * @param {Object} data - the data you wish to render
	 */
	render: function (data) {
		var self = this;
		self.$carousel.append(self.compiledTemplate(data));
		self.initializeCarousel();
	},
	/**
	 * initializeCarousel()
	 * Initialize the carousel cycle2 plugin
	 * @param {Object} data - the data you wish to render
	 */
	initializeCarousel: function() {
			var self = this;
			var settings = {
				fx: "carousel",
				next: self.$element.find('.arrow-next'),
				prev: self.$element.find('.arrow-prev'),
				swipe: true,
				// maxZ: 4,
				slides: ".br-sf-widget-merchant-cont",
				timeout: 0,
				carouselVisible: 2,
				// autoHeight: "calc",
				carouselFluid: true,
				carouselSlideDimension: 4,
				centerVert: true,
				offset: 0
			};

			// Build carousel
			self.$carousel.cycle(settings);
		}
};

// Create the instance defaults from the prototype
bloomreachProductCompare.defaults = bloomreachProductCompare.prototype.defaults;
bloomreachProductCompare.prototype = $.extend({}, HandlebarsCore, bloomreachProductCompare.prototype);

// Register as a JQuery plugin and prevent duplicate instantiation
$.fn[PLUGIN_IDENTIFIER] = function(options) {
	return this.each(function() {
		var instance = $(this).data(PLUGIN_IDENTIFIER);
		if(!instance) {
			instance = new bloomreachProductCompare(this, options).init();
			$(this).data(PLUGIN_IDENTIFIER, instance);
		}
	});
};

});
